import { Component, Inject } from '@angular/core';
import { FormControl, Validators, FormGroup } from '@angular/forms';
import { MatDialogRef as MatDialogRef, MAT_DIALOG_DATA as MAT_DIALOG_DATA } from '@angular/material/dialog';

import { IRpaInfo, IRpaInfoForm } from './../../../models/annex';
import { SnackbarType } from 'src/app/models/snackbar-type.enum';
import { SnackbarService } from 'src/app/services/snackbar.service';

@Component({
  selector: 'app-campo-rpa',
  templateUrl: './campo-rpa.component.html',
  styleUrls: ['./campo-rpa.component.scss']
})
export class CampoRpaComponent {
  rpa = new FormGroup<IRpaInfoForm>({
    RpaNumber: new FormControl<string>(this.data.RpaNumber ?? '', {
      nonNullable: true,
      validators: [Validators.required]
    }),
    RpaDate: new FormControl<string>(this.data.RpaDate ?? '', {
      nonNullable: true,
      validators: [Validators.required]
    }),
    BatchId: new FormControl<string>(this.data.BatchId ?? '', {
      nonNullable: true,
      validators: [Validators.required]
    })
  });

  constructor(
    public dialogRef: MatDialogRef<CampoRpaComponent>,
    private _snackbarService: SnackbarService,
    @Inject(MAT_DIALOG_DATA) public data: IRpaInfo
  ) {}

  close(action: boolean): void {
    if (action) {
      if (this.rpa.controls['RpaNumber'].invalid) {
        this._snackbarService.openSnackBar(
          'Número do RPA é obrigatório!',
          SnackbarType.Danger
        );
        return;
      }

      if (this.rpa.controls['RpaDate'].invalid) {
        this._snackbarService.openSnackBar(
          'Data de Emissão do RPA é obrigatório!',
          SnackbarType.Danger
        );
        return;
      }

      this.dialogRef.close(this.rpa.getRawValue());
    } else {
      this.dialogRef.close(action);
    }
  }
}
